import { Checkbox, Form, InputNumber } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';

import type { EditEdutainmentFormValues } from '../../types';
import styles from './index.module.scss';
import type { PaymentTableData } from './types';

const INPUT_NUMBER_STYLES = { width: '16rem' };

export const getPaymentTableColumns = (args: {
  nonMemberChecked: boolean;
  handleNonMemberCheckedChange: (event: CheckboxChangeEvent) => void;
  checkedPayments: EditEdutainmentFormValues['payments'] | undefined;
}) => {
  const { nonMemberChecked, handleNonMemberCheckedChange, checkedPayments } =
    args;

  const columns: ColumnsType<PaymentTableData> = [
    {
      title: '身分',
      dataIndex: 'isMember',
      render: (isMember: boolean) => {
        if (isMember) {
          return <div className={styles['mb-24']}>會員</div>;
        }
        return (
          <div className={styles['mb-24']}>
            <Checkbox
              checked={nonMemberChecked}
              onChange={handleNonMemberCheckedChange}
            >
              非會員
            </Checkbox>
          </div>
        );
      },
    },
    {
      title: '台幣 (單位:元)',
      dataIndex: 'price',
      render: (_, record) => {
        const canPayByCreditCard = checkedPayments?.includes('creditCard');
        const disabled = record.isMember
          ? !canPayByCreditCard
          : !nonMemberChecked || !canPayByCreditCard;

        return (
          <Form.Item
            name={
              record.isMember
                ? ['pricing', 'member', 'price']
                : ['pricing', 'nonMember', 'price']
            }
            rules={[{ required: !disabled, message: '請輸入數值' }]}
          >
            <InputNumber
              min={1}
              step={1}
              precision={0}
              placeholder="例如：1（不需輸入單位）"
              disabled={disabled}
              style={INPUT_NUMBER_STYLES}
            />
          </Form.Item>
        );
      },
    },
    {
      title: '點數 (單位:點)',
      dataIndex: 'point',
      render: (_, record) => {
        const canPayByPoint = checkedPayments?.includes('point');
        const disabled = record.isMember
          ? !canPayByPoint
          : !nonMemberChecked || !canPayByPoint;

        return (
          <Form.Item
            className={styles['w-full']}
            name={
              record.isMember
                ? ['pricing', 'member', 'point']
                : ['pricing', 'nonMember', 'point']
            }
            rules={[{ required: !disabled, message: '請輸入數值' }]}
          >
            <InputNumber
              min={1}
              step={1}
              precision={0}
              placeholder="例如：1（不需輸入單位）"
              disabled={disabled}
              style={INPUT_NUMBER_STYLES}
            />
          </Form.Item>
        );
      },
    },
    {
      title: '單筆預約上限數量',
      dataIndex: 'limit',
      render: (_, record) => {
        const checkedAnyPayment = checkedPayments && checkedPayments.length > 0;
        const disabled = record.isMember
          ? !checkedAnyPayment
          : !nonMemberChecked || !checkedAnyPayment;

        return (
          <Form.Item
            className={styles['w-full']}
            name={
              record.isMember
                ? ['pricing', 'member', 'limit']
                : ['pricing', 'nonMember', 'limit']
            }
            rules={[{ required: !disabled, message: '請輸入數值' }]}
          >
            <InputNumber
              min={1}
              step={1}
              precision={0}
              placeholder="例如：1（不需輸入單位）"
              disabled={disabled}
              style={INPUT_NUMBER_STYLES}
            />
          </Form.Item>
        );
      },
    },
  ];
  return columns;
};
